export default __webpack_public_path__ + "static/media/avi.d80a34b6.svg";